/* ===== COMMONS ===== */
export const regPhone = /^(010|011|016|017|019)[0-9]*$/;
export const regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const regPassword =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,16}$/;
export const regAccount = /^[0-9]+$/;
